"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceManager = void 0;
var ResourceManager = /** @class */ (function () {
    function ResourceManager() {
        this.resourceMap = {}; // リソースを管理するオブジェクト
    }
    // リソースを追加または更新
    ResourceManager.prototype.addResource = function (name, path) {
        this.resourceMap[name] = path;
    };
    // リソースのパスを取得
    ResourceManager.prototype.getResourcePath = function (name) {
        return this.resourceMap[name];
    };
    return ResourceManager;
}());
exports.ResourceManager = ResourceManager;
//# sourceMappingURL=resourceManager.js.map